import React from 'react';

export default function AtomLoader({ text = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 animate-fade-in w-full h-full min-h-[160px]">
      <div className="atom-loader">
        {/* Central We Guide Logo */}
        <div className="z-10 flex items-center justify-center bg-white rounded-lg shadow-sm border border-slate-100 p-1">
          <img src="/logo.png" alt="We Guide" className="h-4 sm:h-5 w-auto object-contain" />
        </div>
        
        {/* Electron Orbits */}
        <div className="atom-loader-orbit atom-orbit-1">
          <div className="electron"></div>
        </div>
        <div className="atom-loader-orbit atom-orbit-2">
          <div className="electron"></div>
        </div>
        <div className="atom-loader-orbit atom-orbit-3">
          <div className="electron"></div>
        </div>
      </div>
      
      {text && (
        <p className="text-slate-500 text-sm font-semibold tracking-wide animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
}
